import React from 'react';
import { Icon } from './Icon.js';
export const IconAlertWarningFill18 = ({ ...props }) => {
    return (React.createElement(Icon, { size: "18px", ...props },
        React.createElement("path", { d: "M9,11.5c.414,0,.75-.336,.75-.75V2.75c0-.414-.336-.75-.75-.75s-.75,.336-.75,.75V10.75c0,.414,.336,.75,.75,.75Z", fill: "currentColor" }),
        React.createElement("circle", { cx: "9", cy: "15", r: "1", fill: "currentColor", "data-color": "color-2" })));
};
//# sourceMappingURL=IconAlertWarningFill18.js.map